import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { ExpandableMenu } from './ExpandableMenu';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: (theme.topMenu && theme.topMenu.iconColor) || theme.palette.common.white
    },
    button: {
        display: (theme.topMenu && theme.topMenu.display) || undefined
    }
}));

export const TopMenu = (props) => {
    const { onLogOut, logoutLabel, children } = props;

    const classes = useStyles();
    const logOut: () => Promise<void> = onLogOut;

    const menuItems = [
        <MenuItem key="logout" onClick={logOut}>
            {logoutLabel}
        </MenuItem>
    ];

    return (
        <ExpandableMenu
            name="top-menu"
            icon={ExpandMoreIcon}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            classes={classes}
        >
            {menuItems}
            {children}
        </ExpandableMenu>
    );
};

export interface ITopMenuProps {
    onLogOut: () => Promise<void>;
    logoutLabel: string;
}
